<template>
    <modal :show.sync="show" modalClasses="sub-sale-fees-modal" :hide-footer="true" centered>
        <div>
            <div v-if="!levelUnits || levelUnits.length === 0">
                No Units Found.
            </div>
            <div v-else>
                <h3 class="text-center mb-4">
                    Fees Breakdown - Level {{ levelNumber }}
                </h3>

                <!-- Fees content directly here (merged from SubSaleFees.vue) -->
                <div class="card">
                    <div class="card-body py-3">
                        <h3>Fees</h3>

                        <div class="row mt-4">
                            <!-- Booking & Deposit -->
                            <div class="col-12 mb-3 d-flex align-items-center">
                                <span class="mx-2 text-md">Booking Amount</span>
                                <div class="rounded text-xs text-success px-2 py-1" style="background: #E6FFEA;">
                                    <span class="font-weight-600">
                                        RM {{ unitSetting.fees_booking_amount | moneyFormatter }}
                                    </span>
                                </div>
                            </div>

                            <div class="col-12 mb-3 d-flex align-items-center">
                                <span class="mx-2 text-md">Deposit Amount</span>
                                <div class="rounded text-xs text-success px-2 py-1" style="background: #E6FFEA;">
                                    <span class="font-weight-600">
                                        RM {{ unitSetting.fees_deposit_amount | moneyFormatter }}
                                    </span>
                                </div>
                            </div>

                            <!-- Dynamic fee list -->
                            <div 
                                v-for="(fee, key) in feeStatuses" 
                                :key="key"
                                class="col-12 mb-3 d-flex align-items-center"
                                v-if="fee.status"
                            >
                                <span v-html="check"></span>
                                <span class="mx-2 text-md">{{ feeLabels[key] }}</span>
                                
                                <div 
                                    class="rounded text-xs px-2 py-1"
                                    :style="getStatusStyle(fee.status)"
                                    :class="getTextClass(fee.status)"
                                >
                                    <span>{{ fee.status }}</span>
                                    <span class="ml-2 font-weight-600" v-if="fee.amount">
                                        RM {{ fee.amount | moneyFormatter }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <hr class="mt-1 mb-3"/>

                        <!-- Bumi Discount -->
                        <div class="row">
                            <div class="col-12 d-flex align-items-center pb-3">
                                <div class="rounded px-3 py-1 text-md font-weight-600" style="background: #F6F9FD">
                                    {{ unitSetting.bumi_discount_percent || 0 }}%
                                </div>
                                <span class="mx-2 text-md">Bumi Discount</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/Modal"
import { Image, Switch, Button } from 'element-ui'

export default {
    props: ['show_fees_modal'],
    components: {
        Modal,
        [Image.name]: Image,
        [Switch.name]: Switch,
        [Button.name]: Button,
    },
    data() {
        return {
            levelUnits: [],
            levelNumber: '',
            check: '<svg xmlns="http://www.w3.org/2000/svg" class="text-success" width="16" height="16" viewBox="0 0 448 512"><path fill="#0BC196" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-32.8-12.5 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"/></svg>',
        }
    },
    computed: {
        show: {
            get() {
                return this.show_fees_modal
            },
            set(newVal) {
                this.$emit('update:show_fees_modal', newVal)
            },
        },
        unitSetting() {
            // Use first unit's unit_setting (fees are usually identical per level)
            return this.levelUnits.length > 0 ? this.levelUnits[0].unit_setting || {} : {}
        },
        feeStatuses() {
            const s = this.unitSetting
            return {
                fees_spa_legal_fee_status: {
                    status: s.fees_spa_legal_fee_status,
                    amount: s.fees_spa_legal_fee_amount
                },
                fees_spa_disb_status: {
                    status: s.fees_spa_disb_status,
                    amount: s.fees_spa_disb_amount
                },
                fees_spa_stamp_duty_status: {
                    status: s.fees_spa_stamp_duty_status,
                    amount: s.fees_spa_stamp_duty_amount
                },
                fees_loan_legal_fee_status: {
                    status: s.fees_loan_legal_fee_status,
                    amount: s.fees_loan_legal_fee_amount
                },
                fees_loan_disb_status: {
                    status: s.fees_loan_disb_status,
                    amount: s.fees_loan_disb_amount
                },
                fees_loan_stamp_duty_status: {
                    status: s.fees_loan_stamp_duty_status,
                    amount: s.fees_loan_stamp_duty_amount
                },
                fees_mot_status: {
                    status: s.fees_mot_status,
                    amount: s.fees_mot_amount
                },
                fees_valuation_status: {
                    status: s.fees_valuation_status,
                    amount: s.fees_valuation_amount
                },
                fees_maintenance_status: {
                    status: s.fees_maintenance_status,
                    amount: s.fees_maintenance_amount
                },
                fees_sinking_status: {
                    status: s.fees_sinking_status,
                    amount: s.fees_sinking_amount
                }
            }
        },
        feeLabels() {
            return {
                fees_spa_legal_fee_status: 'SPA Legal Fee',
                fees_spa_disb_status: 'SPA Disbursement',
                fees_spa_stamp_duty_status: 'SPA Stamp Duty',
                fees_loan_legal_fee_status: 'Loan Legal Fee',
                fees_loan_disb_status: 'Loan Disbursement',
                fees_loan_stamp_duty_status: 'Loan Stamp Duty',
                fees_mot_status: 'Memorandum of Transfer',
                fees_valuation_status: 'Valuation',
                fees_maintenance_status: 'Maintenance',
                fees_sinking_status: 'Sinking Fund'
            }
        }
    },
    methods: {
        setLevel(level_number, units_on_level) {
            this.levelNumber = level_number
            this.levelUnits = units_on_level
        },
        getStatusStyle(status) {
            if (status === 'Paid by Developer') return { background: '#FFF3F3' }
            if (status === 'Paid by Client') return { background: '#E6FFEA' }
            return {}
        },
        getTextClass(status) {
            if (status === 'Paid by Developer') return 'text-danger'
            if (status === 'Paid by Client') return 'text-success'
            return ''
        }
    },
    filters: {
        moneyFormatter(value) {
            if (!value) return '0.00'
            const num = parseFloat(value)
            if (isNaN(num)) return '0.00'
            return num.toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
    }
}
</script>

<style scoped>
.text-success { color: #0BC196 !important; }
.text-danger { color: #f5365c !important; }

</style>